//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ChevronUpSmallSVG } from './assets/small/chevron-up.inline.svg'

interface ChevronUpSmallIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ChevronUpSmallIcon: React.FC<
  React.PropsWithChildren<ChevronUpSmallIconProps>
> = forwardRef<ChevronUpSmallIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ChevronUpSmallSVG}
      sx={sx}
      color={color}
    />
  )
)
